export default __webpack_public_path__ + "static/media/i15.b2e6fd27.jpeg";